let lineWrapCanvas: HTMLCanvasElement;
const trailingNonAlphanumeric = 'W+$/u';

interface IProps {
  text: string;
  font: string;
  width: number;
  basedOn: string;
  ellipsis: string;
  maxLines: number;
  maxChar: number | undefined;
}

export function clampText({
  text,
  font,
  width,
  basedOn,
  ellipsis,
  maxLines,
  maxChar,
}: IProps) {
  if (!lineWrapCanvas) {
    lineWrapCanvas = document.createElement('canvas');
  }
  const context = lineWrapCanvas.getContext('2d');
  if (!context) {
    return text;
  }

  const spacesAndDashes = /[ ]|(?=—)/g;
  context.font = font;
  const basedOnLetters = basedOn === 'letters';
  const breakOn = basedOnLetters ? '' : ' ';
  const parts = text.split(basedOnLetters ? '' : spacesAndDashes);
  const partsWeCanFit = [parts.shift()];
  let currentLine = partsWeCanFit[0];
  let currentLineIndex = 0;
  let lineCount = 1;

  while (parts.length) {
    const word = parts.shift() || '';
    if (canFit(currentLine + breakOn + word)) {
      addToCurrentLine(word);
    } else {
      lineCount++;
      if (lineCount > maxLines && !maxChar) {
        return addEllipsis();
      }
      if (basedOnLetters) {
        ensureLettersWrap();
      }
      currentLineIndex = partsWeCanFit.length;
      currentLine = word;
      partsWeCanFit.push(word);
    }
  }

  const fullString = partsWeCanFit.join(breakOn);
  const stringFixedDash = fullString.replace(/ —/g, '—');
  return stringFixedDash;

  function canFit(line: string) {
    if (!context) {
      return false;
    }

    return context.measureText(line).width < width;
  }

  function addToCurrentLine(word: string) {
    currentLine += breakOn + word;
    partsWeCanFit.push(word);
  }

  function addEllipsis() {
    while (
      partsWeCanFit.length &&
      !canFit(
        partsWeCanFit
          .slice(currentLineIndex)
          .join(breakOn)
          .replace(trailingNonAlphanumeric, '') + ellipsis
      )
    ) {
      partsWeCanFit.pop();
    }
    return (
      partsWeCanFit
        .join(breakOn)
        .replace(/ —/g, '—')
        .replace(trailingNonAlphanumeric, '') + ellipsis
    );
  }

  function ensureLettersWrap() {
    partsWeCanFit.push(' ');
  }
}
